<template>
  <div class="page-main">
    <div v-if="parentName" class="parent-name">
      <el-icon class="el-icon-school" />
      <span class="m-l-5">{{ parentName }}</span>
    </div>
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" :loading="tableOptions.loading">
      <template #buttons>
        <el-button type="primary" size="mini" @click="batchDo('启用')"> 启用 </el-button>
        <el-button type="info" size="mini" @click="batchDo('禁用')"> 禁用 </el-button>
        <el-button type="danger" size="mini" @click="batchDo('删除')"> 删除 </el-button>
      </template>
      <template #tools>
        <el-button type="success" size="mini" @click="itemDo()"> 新增场地 </el-button>
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      v-bind="tableOptions"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_area_size="{ row }">
        <span>{{ row.area_size }}</span>
        <span>m²</span>
      </template>
      <template #default_limit_count="{ row }">
        <div>
          <span>{{ row.limit_count }}</span>
          <span>{{ row.limit_unit }}</span>
        </div>
        <div class="c-gray">({{ row.end_date }})</div>
      </template>
      <template #default_rent_count="{ row }">
        <span>{{ row.rent_count }}</span>
        <span>元/{{ row.rent_unit }}</span>
      </template>
      <template #default_contract_file="{ row }">
        <div v-for="(item, index) in row.contract_file" :key="index">
          <el-link type="primary" target="_blank" :href="item.url">
            {{ item.name }}
          </el-link>
        </div>
      </template>
      <template #default_ststus="{ row }">
        <el-switch type="primary" v-model="row.status" @change="itemSwitch(row)" />
      </template>
      <template #default_operate="{ row }">
        <el-link type="primary" @click="itemDo(row)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改场地 -->
    <PopupDoSite
      v-if="isShowPopupDoSite"
      :show.sync="isShowPopupDoSite"
      :parentId="parentId"
      :parentName="parentName"
      :detailId="detailId"
      @success="searchListData"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupDoSite: () => import('./popup-do-site')
  },
  props: {
    parentId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      filterData: {},
      headerFilterUrl: '/admin/gcvip/changdi2/searchHeard',
      tableOptions: {
        loading: false,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 187,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          {
            fixed: 'left',
            type: 'checkbox',
            width: 40
          },
          {
            fixed: 'left',
            title: '序号',
            type: 'seq',
            width: 40
          },
          { field: 'type', title: '场地类型', slots: { header: 'header_input' } },
          {
            field: 'area_size',
            title: '面积大小',
            slots: { header: 'header_input', default: 'default_area_size' }
          },
          { field: 'use_type', title: '使用方式', slots: { header: 'header_input' } },
          { field: 'start_date', title: '起租日期', slots: { header: 'header_input' } },
          {
            field: 'limit_count',
            title: '租约期限',
            slots: { header: 'header_input', default: 'default_limit_count' }
          },
          {
            field: 'rent_count',
            title: '租金',
            slots: { header: 'header_input', default: 'default_rent_count' }
          },
          {
            field: 'contract_file',
            title: '租约附件',
            slots: { default: 'default_contract_file' }
          },
          { field: 'remark', title: '备注', slots: { header: 'header_input' } },
          {
            field: 'create_date',
            title: '创建时间',
            width: 160,
            slots: { header: 'header_input' }
          },
          {
            field: 'update_date',
            title: '更新时间',
            width: 160,
            slots: { header: 'header_input' }
          },
          {
            field: 'status',
            title: '状态',
            width: 80,
            slots: { default: 'default_ststus' }
          },
          { title: '操作', width: 160, slots: { default: 'default_operate' } }
        ],
        data: []
      },
      isShowPopupDoSite: false,
      parentName: '',
      detailId: '',
      detailData: {}
    }
  },
  mounted() {
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let filterData = {
        parent_id: this.parentId
      }
      Object.keys(this.filterData).forEach((key) => {
        if (this.filterData[key]) filterData[key] = this.filterData[key]
      })
      this.$api({
        method: 'post',
        url: '/admin/gcvip/changdi2/list',
        data: {
          currentPage: this.tableOptions.pagerConfig.currentPage,
          pageSize: this.tableOptions.pagerConfig.pageSize,
          filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.parentName = res.data.parent_name || ''
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-增改
    itemDo(row) {
      if (row === undefined) {
        this.detailId = ''
      } else {
        this.detailId = row.id
      }
      this.isShowPopupDoSite = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          let params = {
            ids: [row.id],
            type: '删除'
          }
          this.batchDoConfirm(params)
        })
        .catch(() => {})
    },
    // 项-切换状态
    itemSwitch(row) {
      let params = {
        ids: [row.id],
        type: row.status ? '启用' : '禁用'
      }
      this.batchDoConfirm(params)
    },
    // 批量-切换状态
    batchDo(type) {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.$confirm(`您确认要 "批量${type}" 选中的 "${rows.length}" 项数据?`, '提示')
          .then(() => {
            let params = {
              ids: rows.map((item) => item.id),
              type
            }
            this.batchDoConfirm(params)
          })
          .catch(() => {})
      } else {
        this.itemChoosePrompt()
      }
    },
    // 批量操作-确认
    batchDoConfirm(data) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/changdi2/batch',
        data
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('操作成功')
          this.getListData()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  position: relative;
  .parent-name {
    position: absolute;
    top: -36px;
    right: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    color: @colorGrayDeep;
  }
}
</style>
